import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import classNames from 'classnames';
import { message } from 'antd';
import styles from './Sumbit.module.less';
import { PCStoreJsBridge } from '../../nativeapi';
import { getFeedbackTypes, setFeedbackTab, setFeedbackTask } from '../../actions/userFeedback';
// import { setUserFeedbackVisible } from '../../actions/layout';
import RadioGroup from '../../components/Radio/RadioGroup';
import Select from '../../components/Select/Select';
import Checkbox from '../../components/Checkbox/Checkbox';
import { imgLocalUrl, logNative } from '../../utils/utils';
import fail from '../../static/msg-fail.svg';
import feedback_fail from '../../static/feedback_fail.png';
import feedback_succ from '../../static/feedback_succ.png';
import feedback_submit from '../../static/feedback_submiting.png';
import Btn from '../../components/Btn/Btn';
import { logging } from '../../actions/log';
import useLoginStatus from '../../utils/hooks/useLoginStatus';

const selectfeedbackType = createSelector(
  state => state.userFeedback,
  userFeedback => userFeedback.feedbackTypes,
);
const selectTaskIDs = createSelector(
  state => state.userFeedback,
  userFeedback => userFeedback.feedbackTask,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default () => {
  const contactList = [
    { name: 'qq', text: 'QQ' },
    { name: 'email', text: '邮箱' },
    { name: 'wechat', text: '微信' },
    { name: 'phone', text: '手机号' },
  ];
  const feedback_img = {
    true: feedback_succ,
    false: feedback_fail,
    upload: feedback_submit,
  };
  const [textareaRef, setTextareaRef] = useState(null);
  const [contactRef, setContactRef] = useState(null);
  const [feedbackType, setFeedbackType] = useState(null); // 反馈问题类型
  const [activeContactType, setActiveContactType] = useState(contactList[0]); // 反馈联系方式
  const [questionImages, setQuestionImages] = useState([]); // 上传图片的数组
  const [log, setLog] = useState(true); // 是否发送日志
  const [feedbackMessage, setFeedbackMessage] = useState(''); // 反馈问题内容描述
  const userInfo = useSelector(selectUserInfo);
  const feedbackTypes = useSelector(selectfeedbackType);
  const [taskID, setTaskID] = useState(null);
  const [taskIDStatus, setTaskIDStatus] = useState(null);
  const taskIDs = useSelector(selectTaskIDs);
  const dispatch = useDispatch();
  const [isSubmitLogin, setIsSubmitLogin] = useState(false);
  const logInfoData = useSelector(selectLogInfo);
  const [timer, setTimer] = useState(null);
  const loginStatus = useLoginStatus();

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);
  useEffect(() => {
    if (taskIDs) {
      taskIDs.forEach(el => {
        if (el.taskID === taskID && taskIDStatus !== false && taskIDStatus !== true) {
          setTaskIDStatus(el.status);
          // 反馈结果打桩
          if (el.status !== 'upload') {
            dispatch(
              logging({
                category: 'C',
                action: 'Feedback_Result',
                label: '',
                param2: {
                  source: logInfoData.source,
                  source_p: logInfoData.source_p,
                  source_pp: logInfoData.source_pp,
                  status: el.status ? 1 : 0,
                },
              }),
            );
          }
        }
      });
    }
  }, [taskIDs, taskID]);
  // 获取问题类型
  useEffect(() => {
    if (!feedbackTypes || feedbackTypes.length === 0) {
      dispatch(getFeedbackTypes());
    }
  }, []);

  // 处理选中的问题类型
  const handleActiveFeedbackType = question => {
    setFeedbackType(question);
  };

  // 处理发送日志选择框状态
  const handleCheckbox = () => {
    setLog(!log);
  };

  // toast提示框处理函数
  const handleTips = type => {
    const config = {
      number: '上传的图片已超过上限。',
      size: '请将单张图片大小控制在5MB以内。',
    };
    message.destroy();
    message.success({
      content: config[type],
      className: 'ant-message-notice-center',
      icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
      duration: 2.8,
    });
  };

  // 添加图片处理函数
  const handleAddImage = () => {
    if (questionImages && questionImages.length >= 6) {
      handleTips('number');
      return;
    }
    // 调c++弹窗
    PCStoreJsBridge.openSpecialFolder({
      filterTxt: '',
    }).then(res => {
      if (res.succ && res.picArray) {
        const temp = res.picArray.filter(imgInfo => {
          if (imgInfo && imgInfo.size > 5 * 1024 * 1024) {
            handleTips('size');
          }
          return imgInfo && imgInfo.size <= 5 * 1024 * 1024;
        });
        const ll = [...questionImages, ...temp];
        if (ll && ll.length > 6) {
          handleTips('number');
        }
        setQuestionImages(ll.slice(0, 6));
      }
    });
  };

  // 删除已将添加的图片
  const handleReduceImage = (item, index) => () => {
    const list = [...questionImages];
    list.splice(index, 1);
    setQuestionImages(list);
  };

  // 处理选中的联系方式类型
  const handelContact = type => {
    if (type !== activeContactType) {
      setActiveContactType(type);
      if (contactRef) {
        contactRef.textContent = '';
      }
    }
  };
  // 监听输入反馈内容变化的处理，字数提示
  const handleTextArea = () => {
    setFeedbackMessage(textareaRef && textareaRef.value && textareaRef.value.slice(0, 500));

    if (textareaRef && textareaRef.value && textareaRef.value.length > 500) {
      textareaRef.value = textareaRef.value.slice(0, 500);
      message.error({
        content: '您反馈的内容过多，请将字数控制在500字以内!',
        icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        duration: 2.8,
      });
    }
  };

  // 判断登录操作
  const handleLoginStatus = () => {
    if (loginStatus) {
      // 登录
      return true;
    }
    window.CallNativeMethod('login'); // 未登录 调用登录弹窗
    setIsSubmitLogin(true);
    return false;
  };

  // 提交反馈内容
  const handleSumbit = sType => {
    const ids = `${+new Date()}`;
    if (feedbackMessage && handleLoginStatus()) {
      dispatch(
        setFeedbackTask({
          taskID: ids,
          status: 'upload',
          add: true,
        }),
      );
      PCStoreJsBridge.submitFeedbackInfo({
        feedbackType: feedbackType && feedbackType.typeId,
        feedbackMessage,
        contactInfo: `${activeContactType && activeContactType.text} + ${contactRef &&
          contactRef.textContent}`,
        checkLog: log,
        picArray: questionImages,
        taskID: ids,
      });
      setTaskID(ids);
      const timers = setTimeout(() => {
        setTaskIDStatus(state => {
          if (state === 'upload' || state === null) {
            return false;
          }
          return state;
        });
      }, 20000);
      setTimer(timers);
    }
    if (!sType) {
      // 提交反馈打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Feedback_Submit',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  };

  // 主动登陆提交
  useEffect(() => {
    if (isSubmitLogin) {
      if (loginStatus) {
        handleSumbit('auto');
        setIsSubmitLogin(false);
      }
    }
  }, [loginStatus]);

  const handleSkip = () => {
    dispatch(setFeedbackTab('question'));
  };
  return (
    <div className={styles.sumbit}>
      {taskIDStatus === null && (
        <>
          <div className={styles.question_type}>
            <div className={styles.question_type_text}>请选择您要反馈的问题类型：</div>
            <div className={styles.question_type_radios}>
              <RadioGroup group={feedbackTypes} handleChange={handleActiveFeedbackType} />
            </div>
          </div>
          <div className={styles.question_desc}>
            <textarea
              placeholder={
                (feedbackType && feedbackType.prompt) ||
                '您好，请选择您要反馈的问题类型并描述您所遇到的问题，我们会尽快回复。感谢您对联想应用商店的支持！'
              }
              ref={r => setTextareaRef(r)}
              onChange={handleTextArea}
              style={{
                height: questionImages.length > 0 ? '95px' : '140px',
              }}
            />
            <div className={styles.count}>
              {(feedbackMessage && feedbackMessage.length) || 0}
              /500
            </div>
            <ul className={styles.question_desc_images}>
              {questionImages.map((item, index) => (
                <li key={`${item.address}_${index}`} className={styles.question_desc_image_box}>
                  <img src={imgLocalUrl(item.address)} alt="" />
                  <div
                    className={styles.question_desc_images_reduce_btn}
                    onClick={handleReduceImage(item, index)}
                  >
                    <div className={styles.question_desc_images_reduce_str} />
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className={styles.question_images_box}>
            <div className={styles.question_images_add} onClick={handleAddImage}>
              <i
                className={classNames(
                  'icon iconfont icon-feedback_img',
                  styles.question_images_add_icon,
                )}
              />
              添加图片
            </div>
            <div className={styles.question_log}>
              <Checkbox handleChange={handleCheckbox} checked={log} primary>
                <span className={styles.question_log_text}>发送日志帮助我们分析问题</span>
              </Checkbox>
            </div>
          </div>
          <div className={styles.question_contact}>
            <div className={styles.question_contact_desc}>联系方式：</div>
            <div className={styles.question_contact_select}>
              <Select
                options={contactList}
                // defaultValue={contactList[0]}
                primary
                handleChange={handelContact}
              />
            </div>
            <div
              className={styles.question_contact_detail}
              contentEditable
              ref={r => setContactRef(r)}
            />
          </div>
          <div className={styles.question_submit}>
            <Btn
              primary
              className={classNames(styles.question_submit_btn)}
              handleClick={handleSumbit}
              disabled={!feedbackMessage}
            >
              提交反馈
            </Btn>
          </div>
        </>
      )}
      {taskIDStatus !== null && (
        <div className={styles.feedbackMessage}>
          <img src={feedback_img[taskIDStatus]} alt="" className={styles.feedbackMessage_img} />
          <div className={styles.feedbackMessage_text}>
            {taskIDStatus === 'upload' && (
              <>
                <div className={styles.feedbackMessage_text_submiting}>反馈正在提交中</div>
                <div className={styles.feedbackMessage_text_submiting}>
                  提交完成前，请勿关闭窗口以免提交失败
                </div>
              </>
            )}
            {taskIDStatus !== 'upload' && taskIDStatus && '反馈成功！我们会及时处理你的反馈~'}
            {taskIDStatus !== 'upload' && !taskIDStatus && '反馈失败，请稍后再试！'}
          </div>
          {taskIDStatus !== 'upload' && (
            <div className={styles.feedbackMessage_btn}>
              <Btn className={styles.btn} handleClick={handleSkip}>
                查看常见问题
              </Btn>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
